import { FileDetails } from "@/interfaces/files";


function state(): FileDetails {
    return {
        fileId: 0,
        nombre: '',
        clasificacion: 0,
        resultado: '',
        revision: '',
        LC: '',
        estado: 0,
        revisado: 0,
        deletedFile: false,
        txt: '',
        reload: false,
        documents: [],
        reloadFileList: false,
        movingFile: null,
        startTime: null,
        detectedErrors: null,
        paginationData: {},
    }

}

export default state;